import { Component, forwardRef, Input, OnInit, ViewEncapsulation } from '@angular/core';
import {
  AbstractControl,
  ControlContainer,
  ControlValueAccessor,
  FormGroupDirective,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import * as _moment from 'moment';
import { FieldOption } from './../../../models/field.interface';

const moment = _moment;

export interface TimeOption {
  value: number;
  name: string;
}

export enum TimeFrame {
  AM = 'AM',
  PM = 'PM'
}

@Component({
  selector: 'vfs-timepicker',
  templateUrl: './timepicker.component.html',
  styleUrls: [
    './timepicker.component.scss',
    '../inputs/input-number/input-number.component.scss',
    '../select/select.component.scss'
  ],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TimePickerComponent)
    }
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class TimePickerComponent implements OnInit, ControlValueAccessor {
  @Input() format24h = false;
  value: any;
  @Input() label: string;
  @Input() hint: string;
  isDisabled: boolean;

  /** Options to display in the hour selection */
  optionsHours = [] as TimeOption[];
  hour = null;
  @Input() minHour: number;
  @Input() maxHour: number;
  // Minutes
  optionsMinutes = [] as TimeOption[];
  minute = null;
  @Input() minMinute = 0;
  @Input() maxMinute = 59;
  // Time Frame
  optionsTimeFrame: FieldOption[];
  timeFrame = '';

  constructor() {
    this.optionsTimeFrame = [
      {
        label: 'AM',
        value: 'AM'
      },
      {
        label: 'PM',
        value: 'PM'
      }
    ];
    this.onTouch();
    this.onChange(this.value);
  }

  onChange = (_: any) => {};

  onTouch = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  ngOnInit(): void {
    this.minHour = this.minHour !== undefined ? this.minHour : this.format24h ? 0 : 1;
    this.maxHour = this.maxHour !== undefined ? this.maxHour : this.format24h ? 23 : 12;
    // Hours
    for (let index = this.minHour; index <= this.maxHour; index++) {
      this.optionsHours.push({
        value: index,
        name: index < 10 ? `0${index}` : index.toString()
      });
    }
    // Minutes
    for (let index = this.minMinute; index <= this.maxMinute; index += 5) {
      this.optionsMinutes.push({
        value: index,
        name: index < 10 ? `0${index}` : index.toString()
      });
    }
    // Set the hour and minutes in the inputs in case the formcontrol is passed an initial value
    // this.hour = this.value.get('hour');
    // this.minute = this.value.get('minute');
    // this.onTouch();
    // this.onChange(this.value);
    // this.writeValue(this.value);
    // console.log(this.value);
  }

  onInputHour(value: any) {
    let valueInput = +value;
    this.hour = valueInput < 10 ? '0' + valueInput : valueInput;
    this.createTime();
    this.onTouch();
    this.onChange(this.value);
  }

  onInputMinute(value: any) {
    let valueInput = +value;
    this.minute = valueInput < 10 ? '0' + valueInput : valueInput;
    this.createTime();
    this.onTouch();
    this.onChange(this.value);
  }

  onInputTimeFrame(value: any) {
    this.timeFrame = value;
    this.createTime();
    this.onTouch();
    this.onChange(this.value);
  }

  createTime() {
    this.value = moment(
      `${this.hour}:${this.minute} ${this.format24h ? '' : this.timeFrame}`,
      `${this.format24h ? 'HH' : 'hh'}:mm ${this.format24h ? '' : 'A'}`,
      true
    );
  }
}

/** Function to validate if is a correct time  */
export function ValidateTime(control: AbstractControl) {
  if (control.value !== '') {
    return control.value.isValid() ? null : { validTime: false };
  } else {
    return { validTime: false };
  }
}
